import getThreedsToken from "@/api/requests/getThreedsToken";
import CreditCard from "@/types/CreditCard";
import User from "@/types/User";

export default class ThreedsService {
  private token: string | null = null;

  async authenticate(amount: number, user: User, creditcard: CreditCard, installments = 1) {
    if (this.token === null) throw new Error("Token 3DS não configurado");

    window.PagSeguro.setUp({
      session: this.token,
      env: "PROD",
    });

    const payload = {
      data: {
        customer: {
          name: user.name.trim(),
          email: user.email.trim(),
          phones: [
            {
              country: "55",
              area: user.cellphone.substring(0, 2),
              number: user.cellphone.substring(2),
              type: "MOBILE",
            },
          ],
        },
        billingAddress: {
          city: user.address.city.trim(),
          street: user.address.street.trim(),
          regionCode: user.address.state.trim(),
          country: "BRA",
          postalCode: user.address.zipcode.replace(/\D/g, ""),
          number: user.address.number.trim(),
        },
        amount: {
          value: amount,
          currency: "BRL",
        },
        dataOnly: false,
        paymentMethod: {
          type: "CREDIT_CARD",
          card: {
            encrypted: creditcard.encrypted,
          },
          installments: installments,
        },
      },
    };

    try {
      return await window.PagSeguro.authenticate3DS(payload);
    } catch (error) {
      throw new Error((error as PagSeguro3DSError).detail.message);
    }
  }

  async config() {
    const response = await getThreedsToken();
    this.token = response.data.session;
  }
}
